import { useMemo } from 'react';
import { currentAccountConfigVar } from '../../../data/apollo/cache/reactiveVars';

/**
 * Custom hook to extract display configuration from account configuration
 * @param {Object} accountConfig - The account configuration object
 * @returns {Object} The display configuration object with fallback defaults
 */
export const useDisplayConfig = (accountConfig = currentAccountConfigVar()) =>
  useMemo(
    () => ({
      accountTypeLabel: accountConfig.display?.accountTypeLabel || 'Account',
      clientLabel: accountConfig.display?.clientLabel || 'Client',
      adminLabel: accountConfig.display?.adminLabel || 'Admin',
      clientLabelPlural: accountConfig.display?.clientLabelPlural || 'Clients',
      adminLabelPlural: accountConfig.display?.adminLabelPlural || 'Admins',
      hideTaxLabels: accountConfig.display?.hideTaxLabels || false,
    }),
    [accountConfig],
  );

export default useDisplayConfig;
